import {createContext} from "@core-ui/utility";
import {
  CleanedLocale,
  TranslationsForLocale,
  Localize,
  FormatCurrency,
} from "./types";

export type I18nContextType = {
  locale: CleanedLocale;
  translations: TranslationsForLocale;
  localize: Localize;
  formatCurrency: FormatCurrency;
};

const [useI18n, I18nContext]: [
  () => I18nContextType,
  React.Context<I18nContextType | undefined>
] = createContext<I18nContextType>("useLocalize called without I18nProvider");

export {useI18n, I18nContext};
